import { render, staticRenderFns } from "./AccountCertificateFormOther.vue?vue&type=template&id=0357ef7c&scoped=true&"
import script from "./AccountCertificateFormOther.vue?vue&type=script&lang=ts&"
export * from "./AccountCertificateFormOther.vue?vue&type=script&lang=ts&"
import style0 from "./AccountCertificateFormOther.vue?vue&type=style&index=0&id=0357ef7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0357ef7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
